export default "__VITE_ASSET__CDCsm57b__"